// Returns a function that runs at most `limit` async thunks concurrently.
// Bounds compression concurrency to limit, independent of the resultant file upload window.
export function createConcurrencyLimiter(limit) {
  const max = Number.isFinite(limit) ? Math.max(1, Math.trunc(limit)) : 1;
  let active = 0;
  const queue = [];

  // Start the next queued thunk if a slot is free; re-invoked as each finishes.
  const startNext = () => {
    if (active >= max || queue.length === 0) return;
    active++;
    const { fn, resolve, reject } = queue.shift();
    Promise.resolve()
      .then(fn)
      .then(resolve, reject)
      .finally(() => {
        active--;
        startNext();
      });
  };

  return (fn) =>
    new Promise((resolve, reject) => {
      queue.push({ fn, resolve, reject });
      startNext();
    });
}
